/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Tooltip_Other_Open_TasksInputs */

const en_cases_tooltip_other_open_tasks = /** @type {(inputs: Cases_Tooltip_Other_Open_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other open tasks:`)
};

const pt_br2_cases_tooltip_other_open_tasks = /** @type {(inputs: Cases_Tooltip_Other_Open_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outras atividades abertas:`)
};

/**
* | output |
* | --- |
* | "Other open tasks:" |
*
* @param {Cases_Tooltip_Other_Open_TasksInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_tooltip_other_open_tasks = /** @type {((inputs?: Cases_Tooltip_Other_Open_TasksInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Tooltip_Other_Open_TasksInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_tooltip_other_open_tasks(inputs)
	return pt_br2_cases_tooltip_other_open_tasks(inputs)
});